import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import CommentAddIcon from '@atlaskit/icon/core/comment-add';

const i18n = defineMessages({
	addCommentLabel: {
		id: 'comments-panel.add.comment.label',
		defaultMessage: 'Add Comment',
		description: 'Label for button to add a page comment',
	},
});

export const CommentsPanelAddCommentButton = () => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			testId="object-sidebar-panel-add-comment-button"
			appearance="subtle"
			isTooltipDisabled={false}
			icon={CommentAddIcon}
			label={formatMessage(i18n.addCommentLabel)}
		/>
	);
};
